export default __webpack_public_path__ + "static/media/dragonmeat.8ae9ce08.PNG";